<template>
  <div class="devices">
    
    <div class="p-1 bg-black rounded" name="header" style="height:679px;">
        <!-- Header -->
        <div class="row p-1">
            
            <!-- Device Type -->
            <div class="col-md-3">
                <select class="btn text-white fs-4 text-start btn-alchemy-dark w-100 border-bottom-alchemy" v-model="dvmode" :disabled="mode!='default'" style="letter-spacing: 3px;" >
                    <option value="standard_devices">Standard Devices ({{devices.length}})</option>
                    <option value="cloud_devices">Cloud Devices</option>
                </select>
            </div>
            <!-- STANDARD DEVICES Controls -->
            <div v-if="dvmode == 'standard_devices'" class="col-md-9">
                <!-- Filtering -->
                <div v-if="mode=='default'" class="input-group flex-nowrap">
                    <input class="btn fw-light btn-alchemy-dark border-bottom-alchemy fs-4 w-100 me-1" type="text" style="cursor: default;" placeholder="Filter by keyword" v-model="searchWord">
                    <button class="btn btn-alchemy-dark rounded fs-4 me-1" :class="{'bg-gradient border-bottom': searchType=='name'}" @click="setSearchType('name')" title="Filter by Name">
                        <i class="fa-solid fa-desktop"></i>
                    </button>
                    <button class="btn btn-alchemy-dark rounded fs-4 me-1" :class="{'bg-gradient border-bottom': searchType=='alias'}" @click="setSearchType('alias')" title="Filter by Alias">
                        <i class="fa-solid fa-id-badge"></i>
                    </button>
                    <button class="btn btn-alchemy-dark rounded fs-4" :class="{'bg-gradient border-bottom': searchType=='ip'}" @click="setSearchType('ip')" title="Filter by IP Address">
                        <i class="fa-solid fa-network-wired"></i>
                    </button>
                    <div style="width: 5%;"></div>
                    <!-- Refresh -->
                    <button class="btn btn-alchemy-dark bg-gradient fs-4 rounded me-1" :disabled="gettingDevices || alteringDevice || deletingDevice" @click="getDevices(); devices=[];">
                        <i class="fa-solid fa-xl fa-refresh" :class="{'fa-spin': gettingDevices || alteringDevice || deletingDevice}"></i>
                    </button>
                    <!-- Add -->
                    <button class="btn btn-alchemy-dark bg-gradient fs-4 rounded" :disabled="gettingDevices || alteringDevice || deletingDevice" @click="getAvailableDevices(); setAddition(); ">
                        <i class="fa-solid fa-xl fa-plus"></i>
                    </button>
                </div>
                <div v-if="mode=='addition'" class="input-group flex-nowrap">
                    <!-- New Device Selector -->
                    <div class="input-group flex-nowrap">
                        <button class="btn btn-alchemy bg-gradient fs-4 me-1 rounded" :disabled="gettingADevices || alteringDevice || deletingDevice" @click="getAvailableDevices">
                            <i class="fa-solid fa-xl fa-refresh" :class="{'fa-spin': gettingADevices || alteringDevice || deletingDevice}"></i>
                        </button>
                        <select class="btn btn-alchemy text-white text-start fw-light fs-4 w-75 rounded" v-model="deviceToAdd" :disabled="gettingADevices" @change="setNewDevice">
                            <option :value="null">{{availableDevices.length}} available devices to add...</option>
                            <option v-for="(d, i) in availableDevices" v-bind:key="i+1" :value="d" >{{`${d.name} / ${d.ip} / ${d.role} / ${d.os.toUpperCase()}`}}</option>
                        </select>
                        <div style="width: 40%;"></div>
                        <!-- Close Addition -->
                        <button class="btn btn-danger bg-gradient fs-4 rounded" title="Close addition section." @click="clearAddition">
                            <i class="fa-solid fa-xl fa-close"></i>
                        </button>
                    </div>
                </div>
                <div v-if="mode=='edition'" class="input-group flex-nowrap">
                    <!-- Close Edition -->
                    <div style="width: 97%"></div>
                    <button class="btn btn-danger bg-gradient fs-4 rounded" :disabled="alteringDevice" @click="clearEdition">
                        <i class="fa-solid fa-xl fa-close"></i>
                    </button>
                </div>
            </div>

            <!-- CLOUD DEVICES Controls -->
            <div v-if="dvmode == 'cloud_devices'" class="col-md-9">
                <!-- Filtering -->
                <div v-if="mode=='default'" class="input-group flex-nowrap">
                    <select class="btn fw-light btn-alchemy-dark border-bottom-alchemy fs-5 rounded me-1" @change="setCloudDevices" v-model="cloud_dtype">
                        <option v-if="Object.keys(all_cloud_devices).includes('accesspoint')" value="accesspoint">Access Points ({{all_cloud_devices.accesspoint.length}})</option>
                        <option v-if="Object.keys(all_cloud_devices).includes('firewall')" value="firewall">Firewalls ({{all_cloud_devices.firewall.length}})</option>
                    </select>
                    <input class="btn fw-light btn-alchemy-dark border-bottom-alchemy fs-5 w-100 me-1" type="text" style="cursor: default;" placeholder="Filter by keyword" v-model="search_cloud_word">
                    <button class="btn btn-alchemy-dark rounded fs-4 me-1" :class="{'bg-gradient border-bottom': search_cloud_type=='name'}" @click="setCloudSearchType('name')" title="Filter by Name">
                        <i class="fa-solid fa-desktop"></i>
                    </button>
                    <button class="btn btn-alchemy-dark rounded fs-4 me-1" :class="{'bg-gradient border-bottom': search_cloud_type=='alias'}" @click="setCloudSearchType('alias')" title="Filter by Alias">
                        <i class="fa-solid fa-id-badge"></i>
                    </button>
                    <button class="btn btn-alchemy-dark rounded fs-4" :class="{'bg-gradient border-bottom': search_cloud_type=='mac'}" @click="setCloudSearchType('mac')" title="Filter by MAC Address">
                        MAC
                    </button>
                    <div style="width: 5%;"></div>
                    <!-- Refresh -->
                    <button class="btn btn-alchemy-dark bg-gradient fs-4 rounded me-1" :disabled="getting_cloud_devices || altering_cloud_device || deleting_cloud_device" @click="getCloudDevices(); cloud_devices=[];">
                        <i class="fa-solid fa-xl fa-refresh" :class="{'fa-spin': getting_cloud_devices || altering_cloud_device || deleting_cloud_device}"></i>
                    </button>
                    <!-- Add -->
                    <button class="btn btn-alchemy-dark bg-gradient fs-4 rounded" :disabled="getting_cloud_devices || altering_cloud_device || deleting_cloud_device" @click="setCloudAddition(); getAvailableCloudDevices();">
                        <i class="fa-solid fa-xl fa-plus"></i>
                    </button>
                </div>
                <div v-if="mode=='addition'" class="input-group flex-nowrap">
                    <!-- New Device Selector -->
                    <div class="input-group flex-nowrap">
                        <button class="btn btn-alchemy bg-gradient fs-4 rounded me-1" :disabled="getting_acloud_devices || altering_cloud_device || deleting_cloud_device" @click="getAvailableCloudDevices">
                            <i class="fa-solid fa-xl fa-refresh" :class="{'fa-spin': getting_acloud_devices || altering_cloud_device || deleting_cloud_device }"></i>
                        </button>
                        <select class="btn btn-alchemy text-white text-start fw-light fs-4 w-75 rounded" v-model="cloud_device_to_handle" :disabled="getting_acloud_devices || altering_cloud_device" @change="setNewCloudDevice">
                            <option :value="null">{{available_cloud_devices.length}} available cloud devices to add...</option>
                            <option v-for="(d, i) in available_cloud_devices" v-bind:key="i+1" :value="d">{{ `${d.name} / ${d.role} / ${d.os.toUpperCase()}`  }}</option>
                        </select>
                        <div style="width: 40%;"></div>
                        <!-- Close Addition -->
                        <button class="btn btn-danger bg-gradient fs-4 rounded" title="Close addition section." @click="clearCloudAddition">
                            <i class="fa-solid fa-xl fa-close"></i>
                        </button>
                    </div>
                </div>
                <div v-if="mode=='edition'" class="input-group flex-nowrap">
                    <!-- Close Edition -->
                    <div class="input-group flex-nowrap">
                        <input class="btn text-white btn-alchemy w-100 rounded fs-4" type="text" :value="`Cloud Device Edition | ${cloud_device_to_handle.name}`" style="letter-spacing: 3px; cursor: default;" readonly> 
                        <div style="width: 97%"></div>
                        <button class="btn btn-danger bg-gradient fs-4 rounded" :disabled="altering_cloud_device" @click="clearCloudEdition">
                            <i class="fa-solid fa-xl fa-close"></i>
                        </button>
                    </div>
                </div>
            </div>

        </div>
        
        <!-- STANDARD DEVICES space -->
        <div v-if="dvmode == 'standard_devices'">
            <!-- Table -->
            <div v-if="mode=='default'" class="row">
                <div class="col-md-12">
                    <div class="">
                        <div class="tableFixHead mt-1" style="height: 570px;">
                            <table>
                                <thead>
                                        <tr>
                                            <th class="fw-light bg-alchemy-dark bg-gradient text-white fs-5 rounded" style="width: 10px;" title="#">
                                                <i class="fa-solid fa-lg fa-arrow-down-1-9"></i>
                                            </th>
                                            <th class="fw-light bg-alchemy bg-gradient text-white fs-5 rounded p-1" title="Device Role">
                                                <i class="fa-solid fa-lg fa-cube"></i>
                                            </th>
                                            <th class="fw-light bg-alchemy bg-gradient text-white fs-5 rounded p-1" title="Operating System">
                                                OS
                                            </th>
                                            <th class="fw-light bg-alchemy-dark bg-gradient fs-5" style="width: 120px;"  title="Hostname">
                                                <select class="btn text-white" v-model="searchType">
                                                <option value="name">Name</option>
                                                <option value="alias">Alias</option>
                                                <option value="ip">IP Address</option>
                                                </select>
                                            </th>
                                            <th class="fw-light bg-alchemy-dark bg-gradient text-white fs-5" style=""  title="Turn On/Off Device">
                                                <i class="fa-solid fa-lg fa-power-off"></i>
                                            </th>
                                            <th class="fw-light bg-alchemy-dark bg-gradient text-white fs-5" style=""  title="Device Ping">
                                                <i class="fa-solid fa-lg fa-rss"></i>
                                            </th>
                                            <th class="fw-light bg-alchemy-dark bg-gradient text-white fs-5" style=""  title="CPU Usage of Device">
                                                <i class="fa-solid fa-lg fa-microchip"></i>
                                            </th>
                                            <th class="fw-light bg-alchemy-dark bg-gradient text-white fs-5" style=""  title="Memory Usage of Device">
                                                <i class="fa-solid fa-lg fa-memory"></i>
                                            </th>
                                            <th class="fw-light bg-alchemy-dark bg-gradient text-white fs-5" style=""  title="Device Targets">
                                                <i class="fa-solid fa-lg fa-bullseye"></i>
                                            </th>
                                            <th class="fw-light bg-alchemy-dark bg-gradient text-white fs-5" style=""  title="Delete Device">
                                                <i class="fa-solid fa-lg fa-trash"></i>
                                            </th>
                                            <th class="fw-light bg-alchemy-dark bg-gradient text-white fs-5 rounded" style=""  title="Edit Device">
                                                <i class="fa-solid fa-lg fa-pen"></i>
                                            </th>
                                        </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(d, i) in filteredDevices" v-bind:key="i+1"> <!-- Content Row -->
                                        <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50);">
                                            <p class="text-white fs-5 mt-1">{{d.oridx+1}}</p>
                                        </td>
                                        <!-- Role -->
                                        <td class="text-center bg-black" style="width: 10%; border-bottom: solid 1px rgb(50,50,50);">
                                            <button class="btn fw-light btn-alchemy-dark bg-gradient fs-6">
                                                <img id="roleimg" :src="getImage(d.role)" :title="d.role.toUpperCase()" :alt="d.role" width="65" class="img-fluid rounded border-0">
                                            </button>
                                        </td>
                                        <!-- OS -->
                                        <td class="text-center bg-black" style="width: 10%; border-bottom: solid 1px rgb(50,50,50);">
                                            <button class="btn fw-light btn-alchemy-dark bg-gradient fs-6">
                                                <img :src="getImage(oss[d.os])" :title="oss[d.os].toUpperCase()" width="65" class="img-fluid rounded border-0">
                                            </button>
                                        </td>
                                        <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50);">
                                            <p class="text-white fs-6 mt-1">{{d[searchType]}}</p>
                                        </td>
                                        <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50); width: 30px;">
                                            <button class="btn" :class="{'btn-alchemy-dark bg-gradient': !d.active, 'btn-alchemy': d.active}" @click="toggleStatus(d, i, 'active')" :disabled="alteringDevice || deletingDevice || gettingDevices" :title="`Turn On/Off ${d.name} Monitoring.`">
                                                <i class="fa-solid fa-lg fa-power-off"></i>
                                            </button>
                                        </td>
                                        <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50); width: 30px;">
                                            <button class="btn btn-alchemy-success"  :disabled="alteringDevice || deletingDevice || gettingDevices" title="Turn On/Off Ping Checking">
                                                <i class="fa-solid fa-lg fa-rss"></i>
                                            </button>
                                        </td>
                                        <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50); width: 30px;">
                                            <button class="btn" :class="{'btn-alchemy-dark bg-gradient': !d.exec_cpu, 'btn-alchemy': d.exec_cpu}" @click="toggleStatus(d, i, 'exec_cpu')"  :disabled="alteringDevice || deletingDevice || gettingDevices || d.os=='superficial'" title="Turn On/Off CPU Checking">
                                                <i class="fa-solid fa-lg fa-microchip"></i>
                                            </button>
                                        </td>
                                        <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50); width: 30px;">
                                            <button class="btn" :class="{'btn-alchemy-dark bg-gradient': !d.exec_memory, 'btn-alchemy': d.exec_memory}" @click="toggleStatus(d, i, 'exec_memory')"  :disabled="alteringDevice || deletingDevice || gettingDevices || d.os=='superficial'" title="Turn On/Off Memory Checking">
                                                <i class="fa-solid fa-lg fa-memory"></i>
                                            </button>
                                        </td>
                                        <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50); width: 30px;">
                                            <button class="btn" :class="{'btn-alchemy-dark bg-gradient': !d.exec_targets, 'btn-alchemy': d.exec_targets}" @click="toggleStatus(d, i, 'exec_targets')"  :disabled="alteringDevice || deletingDevice || gettingDevices || d.os=='superficial'" title="Turn On/Off Targets Checking">
                                                <i class="fa-solid fa-lg fa-bullseye"></i>
                                            </button>
                                        </td>
                                        <td v-if="false" class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50); width: 30px;">
                                            <button class="btn" :class="{'btn-alchemy-dark bg-gradient': !d.exec_notifications, 'btn-alchemy': d.exec_notifications}" @click="toggleStatus(d, i, 'exec_notifications')"  :disabled="alteringDevice || deletingDevice || gettingDevices" title="Turn On/Off Notifications">
                                                <i class="fa-solid fa-lg fa-bell"></i>
                                            </button>
                                        </td>
                                        <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50); width: 30px;">
                                            <button class="btn btn-alchemy-off bg-gradient" @click="deleteDevice(d, i)" :disabled="alteringDevice || deletingDevice || gettingDevices" :title="`Delete: ${d.name}`">
                                                <i class="fa-solid fa-lg fa-trash"></i>
                                            </button>
                                        </td>
                                        <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50); width: 30px;">
                                            <button class="btn btn-alchemy-dark bg-gradient border-bottom" @click="setEdition(d, i)" :disabled="alteringDevice || deletingDevice || gettingDevices" :title="`Edit: ${d.name}`">
                                                <i class="fa-solid fa-lg fa-pen"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Addition -->
            <div v-if="mode=='addition'"  class="p-1" :class="{'disabled-div': gettingDevices || alteringDevice || deletingDevice}">
                <!-- Set the initial parameters. -->
                <div v-if="deviceToAdd == null">
                    <div class="" style="margin-top: 15%;">
                        <div class="row">
                            <div class="col-md-2"></div>
                            <div class="col-md-8">
                                <div class="input-group">
                                    <button class="btn fs-2 text-alchemy w-100">
                                        <i class="fa-solid fa-lg fa-desktop fa-beat"></i>
                                    </button>
                                    <input v-if="!getting_acloud_devices" type="text" class="btn fs-3 bg-transparent text-white w-100" value="Choose a device from the selector. (Showing only devices with credentials and supported OS.)">
                                    <input v-if="getting_acloud_devices" type="text" class="btn fs-2 bg-transparent text-white w-100" value="Retrieving available cloud devices, please wait.">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="deviceToAdd != null" :class="{'disabled-div': deviceToAdd == null}">
                    <div class="row mt-4" >
                        <!-- Toggle Monitoring & Targets -->
                        <div class="col-md-2 mt-1">
                            <div class="p-1">
                                <div class="bg-dark p-1 rounded">
                                    <input type="text" class="btn bg-alchemy-dark text-white fs-3 fw-light w-100" style="cursor: text;" value="Monitoring" readonly>
                                    <div class="mt-1">
                                        <button class="btn w-100" style="height: 186px; font-size: 60px;" :class="{'btn-alchemy': selected_device.active, 'bg-alchemy-dark bg-gradient': !selected_device.active}" @click="selected_device.active = !selected_device.active">
                                            <i class="fa-solid fa-lg fa-power-off"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="p-1">
                                <div class="bg-dark p-1 rounded">
                                    <input type="text" class="btn bg-alchemy-dark text-white fs-3 fw-light w-100" style="cursor: text;" value="Targets" readonly :disabled="selected_device.os=='superficial'">
                                    <div class="mt-1">
                                        <button class="btn w-100" style="height: 100px; font-size: 60px;" :class="{'btn-alchemy': selected_device.exec_targets, 'bg-alchemy-dark bg-gradient': !selected_device.exec_targets }" @click="selected_device.exec_targets = !selected_device.exec_targets" :disabled="selected_device.os=='superficial'">
                                            <i class="fa-solid fa-lg fa-bullseye"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Ping, CPU, Memory Checking & Tolerance - New -->
                        <div class="col-md-7 mt-1">
                            <div class="p-1">
                                <div class="bg-dark p-1 rounded">
                                    <input type="text" class="btn bg-alchemy-dark text-white fs-3 fw-light w-100" style="cursor: text;" value="Ping Settings" readonly>
                                </div>
                                <div class="bg-dark p-1 rounded mt-2">
                                    <div class="input-group flex-nowrap">
                                        <button  class="btn btn-alchemy fs-4 me-1" style="width: 15%;" >
                                            <i class="fa-solid fa-xl fa-rss"></i>
                                        </button>
                                        <div style="width: 85%;">
                                            <!-- Ping Success Tolerance -->
                                            <div class="input-group flex-nowrap w-100">
                                                <button class="btn bg-alchemy-dark text-white fs-5 fw-light" style="width: 25%;">Success Rate</button>
                                                <div class="p-2 bg-alchemy-dark rounded" style="width: 70%; height: 62px;">
                                                    <input type="range" class="form-range mt-2" min="1" max="100" v-model="selected_device.ping_tolerance">
                                                </div>
                                                <input type="text" class="btn bg-alchemy-dark text-white fs-4" :value="selected_device.ping_tolerance + '%'" style="width: 20%;" readonly>
                                            </div>
                                            <!-- Ping Latency Tolerance -->
                                            <div class="input-group flex-nowrap w-100 mt-1">
                                                <button class="btn bg-alchemy-dark text-white fs-5 fw-light" style="width: 25%;">Ping Latency</button>
                                                <div class="p-2 bg-alchemy-dark rounded" style="width: 70%; height: 62px;">
                                                    <input type="range" class="form-range mt-2" min="1" max="500" v-model="selected_device.ping_latency_tolerance">
                                                </div>
                                                <input type="text" class="btn bg-alchemy-dark text-white fs-4" :value="selected_device.ping_latency_tolerance + ' ms'" style="width: 20%;" readonly>
                                            </div>
                                            <!-- Ping Latency Tolerance -->
                                            <div class="input-group flex-nowrap w-100 mt-1">
                                                <button class="btn bg-alchemy-dark text-white fs-5 fw-light" style="width: 25%;">Ping Jitter</button>
                                                <div class="p-2 bg-alchemy-dark rounded" style="width: 70%; height: 62px;">
                                                    <input type="range" class="form-range mt-2" min="1" max="300" v-model="selected_device.ping_jitter_tolerance">
                                                </div>
                                                <input type="text" class="btn bg-alchemy-dark text-white fs-4" :value="selected_device.ping_jitter_tolerance + ' ms'" style="width: 20%;" readonly>
                                            </div>
                                            <!-- Ping Alarm Limit -->
                                            <div v-if="selected_device.os == 'superficial'" class="input-group flex-nowrap w-100 mt-1">
                                                <button class="btn bg-alchemy-dark text-white fs-5 fw-light" style="width: 25%;">Alarm Limit</button>
                                                <div class="p-2 bg-alchemy-dark rounded" style="width: 70%; height: 62px;">
                                                    <input type="range" class="form-range mt-2" min="1" max="10" v-model.number="selected_device.ping_alarm_limit">
                                                </div>
                                                <input v-if="selected_device.ping_alarm_limit != null" type="text" class="btn bg-alchemy-dark text-white fs-4" :value="selected_device.ping_alarm_limit + ' atts'" style="width: 20%;" readonly>
                                                <input v-if="selected_device.ping_alarm_limit == null" type="text" class="btn bg-alchemy-dark text-white fs-4" :value="'- atts'" style="width: 20%;" readonly>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                        <!-- CPU and Memory Limits -->
                        <div class="col-md-3 mt-1">
                            <div class="p-1">
                                <div class="bg-dark p-1 rounded">
                                    <input type="text" class="btn bg-alchemy-dark text-white fs-3 fw-light w-100" style="cursor: text;" value="Health Settings" readonly>
                                </div>
                                <!-- CPU & Tolerance -->
                                <div class="bg-dark p-1 rounded mt-2">
                                    <div class="input-group flex-nowrap">
                                        <button class="btn fs-3" :class="{'btn-alchemy': selected_device.exec_cpu, 'bg-alchemy-dark': !selected_device.exec_cpu}" style="width: 30%;" :disabled="deviceToAdd.os=='superficial'" 
                                                @click="selected_device.exec_cpu = !selected_device.exec_cpu">
                                            <i class="fa-solid fa-xl fa-microchip"></i>
                                        </button>
                                        <button class="btn bg-alchemy-dark text-white fs-4 fw-light w-100" :disabled="!selected_device.exec_cpu">CPU</button>
                                        <input type="text" class="btn bg-alchemy-dark text-white fs-4"  :value="selected_device.cpu_tolerance + '%'" style="width: 45%;" readonly :disabled="!selected_device.exec_cpu">
                                    </div>
                                    <div class="input-group flex-nowrap mt-1">
                                        <div class="p-2 bg-alchemy-dark rounded w-100" style="height: 62px;" :class="{'disabled-div': !selected_device.exec_cpu}">
                                            <input type="range" class="form-range mt-2" min="1" max="100" v-model="selected_device.cpu_tolerance" :disabled="!selected_device.exec_cpu">
                                        </div>
                                    </div>
                                </div>
                                <!-- Memory & Tolerance -->
                                <div class="bg-dark p-1 rounded mt-3">
                                    <div class="input-group flex-nowrap">
                                        <button  class="btn fs-4" :class="{'btn-alchemy': selected_device.exec_memory, 'bg-alchemy-dark': !selected_device.exec_memory}" style="width: 40%;" :disabled="deviceToAdd.os=='superficial'"  
                                                @click="selected_device.exec_memory = !selected_device.exec_memory">
                                            <i class="fa-solid fa-xl fa-memory"></i>
                                        </button>
                                        <button class="btn bg-alchemy-dark text-white fs-4 fw-light w-100" :disabled="!selected_device.exec_memory">Memory</button>
                                        <input type="text" class="btn bg-alchemy-dark text-white fs-4" :value="selected_device.memory_tolerance + '%'" style="width: 45%;" readonly :disabled="!selected_device.exec_memory">
                                    </div>
                                    <div class="input-group flex-nowrap mt-1">
                                        <div class="input-group flex-nowrap">
                                            <div class="p-2 bg-alchemy-dark rounded w-100" style="height: 62px;" :class="{'disabled-div': !selected_device.exec_memory}">
                                                <input type="range" class="form-range mt-2" min="1" max="100" v-model="selected_device.memory_tolerance" :disabled="!selected_device.exec_memory">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>     
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-4"></div>
                        <div class="col-md-4">
                            <button class="btn btn-alchemy w-100 fs-3" @click="addDevice" :disabled="deviceToAdd == null">
                                <i class="fa-solid fa-lg fa-plus" :class="{'fa-beat-fade': alteringDevice}"></i>
                                Add New Device
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Edition -->
            <div v-if="mode=='edition'" class="" :class="{'disabled-div': gettingDevices || alteringDevice || deletingDevice}"  style="">
                <!-- Header -->
                <div class="row mt-1">
                    <div class="col-md-12">
                        <div class="input-group flex-nowrap">
                            <button class="btn bg-alchemy-dark bg-gradient fs-2 rounded" style="width: 7%; border-right: solid 3px black;">
                                {{selected_device.number}}
                            </button>
                            <input type="text" class="btn bg-alchemy-dark bg-gradient fs-2 fw-light text-start" style="width: 93%; border-right: solid 3px black;" :value="selected_device.name" readonly>
                            <button class="btn btn-alchemy fs-3" style="width: 10%;" @click="editDevice" :disabled="alteringDevice">
                                <i class="fa-solid fa-lg fa-save" :class="{'fa-beat-fade': alteringDevice}"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <!-- Customizing -->
                <div class="row mt-1">
                    <!-- Toggle Monitoring & Targets -->
                    <div class="col-md-2 mt-1">
                        <div class="p-1">
                            <div class="bg-dark p-1 rounded">
                                <input type="text" class="btn bg-alchemy-dark text-white fs-3 fw-light w-100" style="cursor: text;" value="Monitoring" readonly>
                                <div class="mt-1">
                                    <button class="btn w-100" style="height: 186px; font-size: 60px;" :class="{'btn-alchemy': selected_device.active, 'bg-alchemy-dark bg-gradient': !selected_device.active}" @click="selected_device.active = !selected_device.active">
                                        <i class="fa-solid fa-lg fa-power-off"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="p-1">
                            <div class="bg-dark p-1 rounded">
                                <input type="text" class="btn bg-alchemy-dark text-white fs-3 fw-light w-100" style="cursor: text;" value="Targets" readonly :disabled="selected_device.os=='superficial'">
                                <div class="mt-1">
                                    <button class="btn w-100" style="height: 100px; font-size: 60px;" :class="{'btn-alchemy': selected_device.exec_targets, 'bg-alchemy-dark bg-gradient': !selected_device.exec_targets }" @click="selected_device.exec_targets = !selected_device.exec_targets" :disabled="selected_device.os=='superficial'">
                                        <i class="fa-solid fa-lg fa-bullseye"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Ping, CPU, Memory Checking & Tolerance - Edition -->
                    <div class="col-md-7 mt-1">
                        <div class="p-1">
                            <div class="bg-dark p-1 rounded">
                                <input type="text" class="btn bg-alchemy-dark text-white fs-3 fw-light w-100" style="cursor: text;" value="Health & Connectivity Tolerances" readonly>
                            </div>
                            <div class="bg-dark p-1 rounded mt-2">
                                <div class="input-group flex-nowrap">
                                    <button  class="btn btn-alchemy fs-4 me-1" style="width: 15%;" >
                                        <i class="fa-solid fa-xl fa-rss"></i>
                                    </button>
                                    <div style="width: 85%;">
                                        <!-- Ping Success Tolerance -->
                                        <div class="input-group flex-nowrap w-100">
                                            <button class="btn bg-alchemy-dark text-white fs-5 fw-light" style="width: 25%;">Success Rate</button>
                                            <div class="p-2 bg-alchemy-dark rounded" style="width: 70%; height: 62px;">
                                                <input type="range" class="form-range mt-2" min="1" max="100" v-model="selected_device.ping_tolerance">
                                            </div>
                                            <input type="text" class="btn bg-alchemy-dark text-white fs-4" :value="selected_device.ping_tolerance + '%'" style="width: 20%;" readonly>
                                        </div>
                                        <!-- Ping Latency Tolerance -->
                                        <div class="input-group flex-nowrap w-100 mt-1">
                                            <button class="btn bg-alchemy-dark text-white fs-5 fw-light" style="width: 25%;">Ping Latency</button>
                                            <div class="p-2 bg-alchemy-dark rounded" style="width: 70%; height: 62px;">
                                                <input type="range" class="form-range mt-2" min="1" max="500" v-model="selected_device.ping_latency_tolerance">
                                            </div>
                                            <input type="text" class="btn bg-alchemy-dark text-white fs-4" :value="selected_device.ping_latency_tolerance + ' ms'" style="width: 20%;" readonly>
                                        </div>
                                        <!-- Ping Latency Tolerance -->
                                        <div class="input-group flex-nowrap w-100 mt-1">
                                            <button class="btn bg-alchemy-dark text-white fs-5 fw-light" style="width: 25%;">Ping Jitter</button>
                                            <div class="p-2 bg-alchemy-dark rounded" style="width: 70%; height: 62px;">
                                                <input type="range" class="form-range mt-2" min="1" max="300" v-model="selected_device.ping_jitter_tolerance">
                                            </div>
                                            <input type="text" class="btn bg-alchemy-dark text-white fs-4" :value="selected_device.ping_jitter_tolerance + ' ms'" style="width: 20%;" readonly>
                                        </div>
                                        <!-- Ping Alarm Limit -->
                                        <div v-if="selected_device.os == 'superficial'" class="input-group flex-nowrap w-100 mt-1">
                                            <button class="btn bg-alchemy-dark text-white fs-5 fw-light" style="width: 25%;" :title="`Current alarm counter: ${selected_device.ping_alarm_counter}`">Alarm Limit</button>
                                            <div class="p-2 bg-alchemy-dark rounded" style="width: 70%; height: 62px;">
                                                <input type="range" class="form-range mt-2" min="1" max="10" v-model="selected_device.ping_alarm_limit">
                                            </div>
                                            <input type="text" class="btn bg-alchemy-dark text-white fs-4" :value="selected_device.ping_alarm_limit + ' atts'" style="width: 20%;" readonly>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- CPU & Tolerance -->
                            <div v-if="false" class="bg-dark p-1 rounded mt-2">
                                <div class="input-group flex-nowrap">
                                    <button class="btn fs-4 me-1" :class="{'btn-alchemy': selected_device.exec_cpu, 'bg-alchemy-dark': !selected_device.exec_cpu}" style="width: 15%;" 
                                            @click="selected_device.exec_cpu = !selected_device.exec_cpu" :disabled="selected_device.os=='superficial'">
                                        <i class="fa-solid fa-xl fa-microchip"></i>
                                    </button>
                                    <div class="input-group flex-nowrap" style="width: 85%;">
                                        <button class="btn bg-alchemy-dark text-white fs-5 fw-light" style="width: 25%;" :disabled="!selected_device.exec_cpu">CPU</button>
                                        <div class="p-2 bg-alchemy-dark rounded" style="width: 70%; height: 62px;" :class="{'disabled-div': !selected_device.exec_cpu}">
                                            <input type="range" class="form-range mt-2" min="1" max="100" v-model="selected_device.cpu_tolerance" :disabled="!selected_device.exec_cpu">
                                        </div>
                                        <input type="text" class="btn bg-alchemy-dark text-white fs-4"  :value="selected_device.cpu_tolerance + '%'" style="width: 20%;" readonly :disabled="!selected_device.exec_cpu">
                                    </div>
                                </div>
                            </div>
                            <!-- Memory & Tolerance -->
                            <div v-if="false" class="col-md-12 mt-2">
                                <div class="bg-dark p-1 rounded">
                                    <div class="input-group flex-nowrap">
                                        <button  class="btn fs-4 me-1" :class="{'btn-alchemy': selected_device.exec_memory, 'bg-alchemy-dark': !selected_device.exec_memory}" style="width: 15%;" 
                                                @click="selected_device.exec_memory = !selected_device.exec_memory" :disabled="selected_device.os=='superficial'">
                                            <i class="fa-solid fa-xl fa-memory"></i>
                                        </button>
                                        <div class="input-group flex-nowrap" style="width: 85%;">
                                            <button class="btn bg-alchemy-dark text-white fs-5 fw-light" style="width: 25%;" :disabled="!selected_device.exec_memory">Memory</button>
                                            <div class="p-2 bg-alchemy-dark rounded" style="width: 70%; height: 62px;" :class="{'disabled-div': !selected_device.exec_memory}">
                                                <input type="range" class="form-range mt-2" min="1" max="100" v-model="selected_device.memory_tolerance" :disabled="!selected_device.exec_memory">
                                            </div>
                                            <input type="text" class="btn bg-alchemy-dark text-white fs-4" :value="selected_device.memory_tolerance + '%'" style="width: 20%;" readonly :disabled="!selected_device.exec_memory">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- CPU and Memory Limits -->
                    <div class="col-md-3 mt-1">
                        <div class="p-1">
                            <div class="bg-dark p-1 rounded">
                                <input type="text" class="btn bg-alchemy-dark text-white fs-3 fw-light w-100" style="cursor: text;" value="Health Settings" readonly>
                            </div>
                            <!-- CPU & Tolerance -->
                            <div class="bg-dark p-1 rounded mt-2">
                                <div class="input-group flex-nowrap">
                                    <button class="btn fs-3" :class="{'btn-alchemy': selected_device.exec_cpu, 'bg-alchemy-dark': !selected_device.exec_cpu}" style="width: 30%;" :disabled="selected_device.os=='superficial'" 
                                            @click="selected_device.exec_cpu = !selected_device.exec_cpu">
                                        <i class="fa-solid fa-xl fa-microchip"></i>
                                    </button>
                                    <button class="btn bg-alchemy-dark text-white fs-4 fw-light w-100" :disabled="!selected_device.exec_cpu">CPU</button>
                                    <input type="text" class="btn bg-alchemy-dark text-white fs-4"  :value="selected_device.cpu_tolerance + '%'" style="width: 45%;" readonly :disabled="!selected_device.exec_cpu">
                                </div>
                                <div class="input-group flex-nowrap mt-1">
                                    <div class="p-2 bg-alchemy-dark rounded w-100" style="height: 62px;" :class="{'disabled-div': !selected_device.exec_cpu}">
                                        <input type="range" class="form-range mt-2" min="1" max="100" v-model="selected_device.cpu_tolerance" :disabled="!selected_device.exec_cpu">
                                    </div>
                                </div>
                            </div>
                            <!-- Memory & Tolerance -->
                            <div class="bg-dark p-1 rounded mt-3">
                                <div class="input-group flex-nowrap">
                                    <button  class="btn fs-4" :class="{'btn-alchemy': selected_device.exec_memory, 'bg-alchemy-dark': !selected_device.exec_memory}" style="width: 40%;" :disabled="selected_device.os=='superficial'"  
                                            @click="selected_device.exec_memory = !selected_device.exec_memory">
                                        <i class="fa-solid fa-xl fa-memory"></i>
                                    </button>
                                    <button class="btn bg-alchemy-dark text-white fs-4 fw-light w-100" :disabled="!selected_device.exec_memory">Memory</button>
                                    <input type="text" class="btn bg-alchemy-dark text-white fs-4" :value="selected_device.memory_tolerance + '%'" style="width: 45%;" readonly :disabled="!selected_device.exec_memory">
                                </div>
                                <div class="input-group flex-nowrap mt-1">
                                    <div class="input-group flex-nowrap">
                                        <div class="p-2 bg-alchemy-dark rounded w-100" style="height: 62px;" :class="{'disabled-div': !selected_device.exec_memory}">
                                            <input type="range" class="form-range mt-2" min="1" max="100" v-model="selected_device.memory_tolerance" :disabled="!selected_device.exec_memory">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- CLOUD DEVICES space -->
        <div v-if="dvmode == 'cloud_devices'">
            <!-- ACCESS POINTS -->
            <!-- Table Access Points-->
            <div v-if="mode=='default' && ['accesspoint','firewall'].includes(cloud_dtype)" class="row">
                <div class="col-md-12">
                    <div class="">
                        <div class="tableFixHead mt-1" style="height: 570px; ">
                            <table>
                                <thead>
                                        <tr style="overflow-y: scroll;">
                                            <th class="fw-light bg-alchemy-dark bg-gradient text-white fs-5 rounded" style="width: 10px;" title="#">
                                                <i class="fa-solid fa-lg fa-arrow-down-1-9"></i>
                                            </th>
                                            <th class="fw-light bg-alchemy bg-gradient text-white fs-5 rounded p-1" title="Device Role">
                                                <i class="fa-solid fa-lg fa-cube"></i>
                                            </th>
                                            <th class="fw-light bg-alchemy bg-gradient text-white fs-5 rounded p-1" title="Operating System">
                                                OS
                                            </th>
                                            <th class="fw-light bg-alchemy-dark bg-gradient fs-5" style="width: 120px;"  title="Hostname">
                                                <select class="btn text-white" v-model="search_cloud_type">
                                                    <option value="name">Name</option>
                                                    <option value="alias">Alias</option>
                                                    <option value="mac">MAC Address</option>
                                                </select>
                                            </th>
                                            <th class="fw-light bg-alchemy-dark bg-gradient text-white fs-5" style=""  title="Turn On/Off Monitoring">
                                                <i class="fa-solid fa-lg fa-power-off"></i>
                                            </th>
                                            <th class="fw-light bg-alchemy-dark bg-gradient text-white fs-5" style=""  title="Delete device from alchemy.">
                                                <i class="fa-solid fa-lg fa-trash"></i>
                                            </th>
                                            <th class="fw-light bg-alchemy-dark bg-gradient text-white fs-5" style=""  title="Edit device.">
                                                <i class="fa-solid fa-lg fa-pen"></i>
                                            </th>
                                        </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(d, i) in filteredCloudDevices" v-bind:key="i+1"> <!-- Content Row -->
                                        <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50);">
                                            <p class="text-white fs-5 mt-1">{{i+1}}</p>
                                        </td>
                                        <!-- Role -->
                                        <td class="text-center bg-black" style="width: 10%; border-bottom: solid 1px rgb(50,50,50);">
                                            <button class="btn fw-light btn-alchemy-dark bg-gradient fs-6">
                                                <img id="roleimg" :src="getImage(d.role)" :title="d.role.toUpperCase()" :alt="d.role" width="65" class="img-fluid rounded border-0">
                                            </button>
                                        </td>
                                        <!-- OS -->
                                        <td class="text-center bg-black" style="width: 10%; border-bottom: solid 1px rgb(50,50,50);">
                                            <button class="btn fw-light btn-alchemy-dark bg-gradient fs-6">
                                                <img :src="getImage(oss[d.os])" :title="oss[d.os].toUpperCase()" width="65" class="img-fluid rounded border-0">
                                            </button>
                                        </td>
                                        <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50); width: 40%;">
                                            <p class="text-white fs-6 mt-1" style="text-transform: uppercase;">{{d[search_cloud_type]}}</p>
                                        </td>
                                        <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50); width: 30px;">
                                            <button class="btn" :class="{'btn-alchemy-dark bg-gradient': !d.active, 'btn-alchemy': d.active}" @click="toggleCloudDeviceField(d, i, 'active')" :disabled="altering_cloud_device || deleting_cloud_device || getting_cloud_devices" :title="`Turn On/Off ${d.name} Monitoring.`">
                                                <i class="fa-solid fa-lg fa-power-off"></i>
                                            </button>
                                        </td>
                                        <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50); width: 30px;">
                                            <button class="btn btn-alchemy-off bg-gradient" @click="deleteCloudDevice(d, i)" :disabled="altering_cloud_device || deleting_cloud_device || getting_cloud_devices" :title="`Delete: ${d.name}`">
                                                <i class="fa-solid fa-lg fa-trash"></i>
                                            </button>
                                        </td>
                                        <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50); width: 30px;">
                                            <button class="btn btn-alchemy-dark bg-gradient border-bottom" @click="setCloudEdition(d)" :disabled="altering_cloud_device || deleting_cloud_device || getting_cloud_devices" :title="`Edit: ${d.name}`">
                                                <i class="fa-solid fa-lg fa-pen"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <!-- General Cloud Addition -->
            <div v-if="['addition','edition'].includes(mode) && ['accesspoint','firewall'].includes(cloud_dtype)"  class="p-1" :class="{'disabled-div': getting_cloud_devices || altering_cloud_device || deleting_cloud_device}">
               
                <!-- Access Point Limits -->
                <div v-if="cloud_device_to_handle == null">
                    <div class="" style="margin-top: 15%;">
                        <div class="row">
                            <div class="col-md-2"></div>
                            <div class="col-md-8">
                                <div class="input-group">
                                    <button class="btn fs-2 text-alchemy w-100">
                                        <i class="fa-solid fa-lg fa-cloud fa-beat"></i>
                                    </button>
                                    <input v-if="!getting_acloud_devices" type="text" class="btn fs-2 bg-transparent text-white w-100" value="Waiting for selection...">
                                    <input v-if="getting_acloud_devices" type="text" class="btn fs-2 bg-transparent text-white w-100" value="Retrieving available cloud devices, please wait.">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="cloud_device_to_handle != null" class="p-1 mt-3">
                    <div v-if="cloud_device_to_handle.role == 'accesspoint'" class="row mb-5">
                        <div class="col-md-2"></div>
                        <div class="col-md-2">
                            <div class="rounded">
                                <input type="text" class="btn bg-alchemy text-white fs-4 w-100 border-bottom-alchemy border-top-alchemy" readonly :value="'Monitoring'">
                                <div class="mt-1">
                                    <button class="btn w-100" style="height: 186px; font-size: 60px;" :class="{'btn-alchemy': cloud_device_to_handle.active, 'bg-alchemy-dark bg-gradient': !cloud_device_to_handle.active}" @click="cloud_device_to_handle.active = !cloud_device_to_handle.active">
                                        <i class="fa-solid fa-lg fa-power-off"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <input type="text" class="btn bg-alchemy text-white fs-4 w-100 border-bottom-alchemy border-top-alchemy" readonly value="Data">
                            <div class="input-group flex-nowrap mt-2">
                                <button class="btn btn-alchemy fs-4">
                                    <i class="fa-solid fa-lg fa-id-badge"></i>
                                </button>
                                <input type="text" class="btn bg-alchemy text-white fs-4 w-100 bg-gradient" style="cursor: text;" v-model="cloud_device_to_handle.alias" placeholder="Alias">
                            </div>
                            <input type="text" class="btn bg-alchemy text-white fs-4 w-100 border-bottom-alchemy border-top-alchemy mt-4" readonly value="Access Point Limits">
                            <!-- Radio Percentage Limit -->
                            <div class="input-group flex-nowrap w-100 border-bottom-alchemy">
                                <button class="btn bg-alchemy text-white fs-6 fw-light" style="width: 35%;">Radio Percentage Limit</button>
                                <div class="p-2 bg-alchemy-dark rounded" style="width: 70%; height: 62px;">
                                    <input type="range" class="form-range mt-2" min="1" max="100" v-model="limits.accesspoint.radio_percentage_limit">
                                </div>
                                <input type="text" class="btn bg-alchemy-dark text-white fs-4" :value="limits.accesspoint.radio_percentage_limit + '%'" style="width: 20%;" readonly>
                            </div>
                        </div>
                        <div v-if="false" class="col-md-4">
                            <input type="text" class="btn bg-alchemy text-white fs-4 w-100 border-bottom-alchemy border-top-alchemy" readonly value="Notificators">
                            <div class="rounded">
                                <div class="bg-alchemy rounded" style="height: 430px;">
                                    <div v-if="cloud_device_to_handle != null"  class="bg-alchemy-dark p-1 mt-1 rounded" style="height: 362px; overflow-y: scroll;">
                                        <div class="input-group flex-nowrap" v-for="(nt, nti) in cloud_device_to_handle.notificators" v-bind:key="nti+1">
                                            <button class="btn fs-6 mb-1 w-100 text-start" :class="{'btn-alchemy': nt.include, 'btn-alchemy-off bg-gradient': !nt.include}" @click="nt.include = !nt.include">
                                                <i class="fa-solid fa-lg" :class="{'fa-bell': nt.include, 'fa-bell-slash': !nt.include}"></i>
                                                {{nt.name.toUpperCase()}} | {{nt.type.replace('_','-').toUpperCase()}}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="cloud_device_to_handle.role == 'firewall'" class="row mb-5">
                        <div class="col-md-2"></div>
                        <div class="col-md-3">
                            <div class="rounded">
                                <input type="text" class="btn bg-alchemy text-white fs-4 w-100 border-bottom-alchemy border-top-alchemy" readonly :value="'Monitoring'">
                                <div class="mt-1">
                                    <button class="btn w-100" style="height: 186px; font-size: 60px;" :class="{'btn-success': cloud_device_to_handle.active, 'bg-alchemy-dark bg-gradient': !cloud_device_to_handle.active}" @click="cloud_device_to_handle.active = !cloud_device_to_handle.active">
                                        <i class="fa-solid fa-lg fa-power-off"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <input type="text" class="btn bg-alchemy text-white fs-4 w-100 border-bottom-alchemy border-top-alchemy" readonly value="Data">
                            <div class="input-group flex-nowrap mt-2">
                                <button class="btn btn-alchemy fs-4">
                                    <i class="fa-solid fa-lg fa-id-badge"></i>
                                </button>
                                <input type="text" class="btn bg-alchemy text-white fs-4 w-100 border-bottom-alchemy" style="cursor: text;" v-model="cloud_device_to_handle.alias" placeholder="Alias">
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-2"></div>
                        <div class="col-md-8">
                            <button v-if="mode=='addition'" class="btn btn-success fs-4 w-100" @click="addCloudDevice" :disabled="cloud_device_to_handle == null">
                                <i class="fa-solid fa-lg fa-plus" :class="{'fa-beat-fade': altering_cloud_device}"></i>
                                Add Device
                            </button>
                            <button v-if="mode=='edition'" class="btn btn-alchemy fs-4 w-100" @click="editCloudDevice" :disabled="cloud_device_to_handle == null">
                                <i class="fa-solid fa-lg fa-save" :class="{'fa-beat-fade': altering_cloud_device}"></i>
                                Save Device Changes
                            </button>
                        </div>
                    </div>
                </div>

            </div>

        </div>

    </div>

  </div>
</template>

<script>
// Import the component with the line below.
//import Base from '@/components/Base.vue'

// Add this to parent headerbar: @setAppSection="setAppSection($event)"

import axios from "axios";

export default {
  name: 'Devices',
  components: {},
  data(){
    return {
      // General
        appclient: null,
        site: null,
        stage: null,
        mode: "default",
        dvmode: 'standard_devices', // Devices Mode
      // Standard Devices
        availableDevices: [],
        gettingADevices: false,
        devices: [],
        devicesMessage: "Manage your devices in monitoring.",
        gettingDevices: false,
        selected_device: {
            name: "default",
            ip: "x.x.x.x",
            os: 'os',
            active: true,
            exec_ping: true,
            ping_tolerance: 80,
            ping_latency_tolerance: 50,
            ping_jitter_tolerance: 20,
            ping_alarm_limit: 2,
            exec_cpu: true,
            cpu_tolerance: 60,
            exec_memory: true,
            memory_tolerance: 60,
            exec_targets: false,
            exec_notifications: true
        },
        default_device: {
            name: "default",
            ip: "x.x.x.x",
            os: 'os',
            active: true,
            exec_ping: true,
            ping_tolerance: 80,
            ping_latency_tolerance: 50,
            ping_jitter_tolerance: 20,
            ping_alarm_limit: 2,
            exec_cpu: true,
            cpu_tolerance: 60,
            exec_memory: true,
            memory_tolerance: 60,
            exec_targets: false,
            exec_notifications: true
        },

      // -- Add device to alchemy.
        deviceToAdd: null,
        bases: {
          // Device Roles
          role: require("@/assets/img/bases/roles/default_device_role.png"),
          router: require("@/assets/img/bases/roles/base_router.png"),
          switch: require("@/assets/img/bases/roles/base_switch.png"),
          server: require("@/assets/img/bases/roles/base_server.png"),
          accesspoint: require("@/assets/img/bases/roles/base_ap.png"),
          firewall: require("@/assets/img/bases/roles/base_firewall.png"),
          other: require("@/assets/img/bases/roles/base_other.png"),
          // Device OS's
          os: require("@/assets/img/bases/os/default_device_os.png"),
          ios: require("@/assets/img/bases/os/base_cisco_ios.png"),
          iosxr: require("@/assets/img/bases/os/base_cisco_xr.png"),
          iosxe: require("@/assets/img/bases/os/base_cisco_xe.png"),
          reap: require("@/assets/img/bases/os/base_reap.png"),
          reap2900: require("@/assets/img/bases/os/base_reap_2900.png"),
          rax700: require("@/assets/img/bases/os/base_reap_rax700.png"),
          ros: require("@/assets/img/bases/os/base_ros.png"),
          ros2800: require("@/assets/img/bases/os/base_ros_2800.png"),
          timos: require("@/assets/img/bases/os/base_timos.png"),
          vrp: require("@/assets/img/bases/os/base_vrp.png"),
          huawei: require("@/assets/img/bases/os/base_huawei.png"),
          ubuntu: require("@/assets/img/bases/os/base_ubuntu.png"),
          meraki: require("@/assets/img/bases/os/base_meraki.png"),
          superficial: require("@/assets/img/bases/os/base_superficial.png")
        },
        oss:{
            os:           'os',
            ios:          'ios',
            iosxr:        'iosxr',
            iosxe:        'iosxe',
            huawei:       'vrp',
            alu:          'timos',
            raisecom2900: 'reap2900',
            raisecom2800: 'ros2800',
            rax700:       'rax700',
            ubuntu:       'ubuntu',
            meraki:       'meraki',
            superficial:  'superficial'
        },

      // -- Deleting device from alchemy.
        deletingDevice: false,

      // -- Edit device of alchemy 
        alteringDevice: false,

      // -- Filtering
        searchWord: "",
        searchType: "name",
      
      // CLOUD DEVICES
      all_cloud_devices: {},
      cloud_dtype: 'accesspoint',
      cloud_devices: [],
      cloud_device_to_handle: null,
      available_cloud_devices: [],
      getting_acloud_devices: false,
      getting_cloud_devices: false,
      altering_cloud_device: false,
      deleting_cloud_device: false,

      // Add
      selected_cloud_device: {},
      // Limits & Tolerances
      limits: {
        accesspoint:{
            radio_percentage_limit: null
        }
      },


      // -- Filtering
      search_cloud_word: "",
      search_cloud_type: "name"
          
    }
  },
  methods:{
    // STANDARD DEVICES
    getAvailableDevices(){
        this.deviceToAdd = null
        this.devicesMessage = "Getting available devices..."
        this.gettingADevices = true
        this.availableDevices = []
        const params = {}
        const dest = this.site + '/alchemy/devices/getAvailableDevices'
        axios
            .get(dest, {params})
            .then(rx => {
                // OK
                this.availableDevices = rx.data.data.devices
                this.gettingADevices = false
                this.devicesMessage = "..."
            })
            .catch(error => {
                this.gettingADevices = false
                this.devicesMessage = this.processErrorMessage(error)
        });
    },
    getDevices(){
        this.devicesMessage = "Getting devices..."
        this.gettingDevices = true
        //this.devices = []
        const params = {filter: 'all'}
        const dest = this.site + '/alchemy/devices/getDevices'
        axios
            .get(dest, {params})
            .then(rx => {
                // OK
                this.devices = rx.data.data.devices
                this.gettingDevices = false
                this.devicesMessage = "..."
            })
            .catch(error => {
                this.gettingDevices = false
                this.devicesMessage = this.processErrorMessage(error)
        });
    },
    toggleStatus(_dev, _ind, _field){
        this.alteringDevice = true
        this.devicesMessage = "Modifying status of device, please wait..."
        const params = {uid: _dev.uid, status: !Boolean(_dev[_field]), field: _field}
        const dest = this.site + '/alchemy/devices/toggleStatus'
        axios
            .post(dest, {params})
            .then(rx => {
                // OK
                this.getDevices()
                this.alteringDevice = false
                this.devicesMessage = "..."
            })
            .catch(error => {
                this.processErrorMessage(error)
                this.alteringDevice = false
            });
    },
    // Addition
    addDevice(){
        this.selected_device.exec_ping = true
        this.selected_device.uid = this.deviceToAdd.uid
        this.selected_device.name = this.deviceToAdd.name
        this.selected_device.alias = this.deviceToAdd.alias
        this.selected_device.ip = this.deviceToAdd.ip
        this.selected_device.role = this.deviceToAdd.role
        this.selected_device.rawos = this.deviceToAdd.os
        this.selected_device.os = this.oss[this.deviceToAdd.os]
        this.selected_device.category = this.deviceToAdd.category
        this.selected_device.latitude = this.deviceToAdd.latitude
        this.selected_device.longitude = this.deviceToAdd.longitude
        this.selected_device.notificators = this.cloneObject(this.deviceToAdd.notificators)
        this.alteringDevice = true
        const params = {}
        const dest = this.site + '/alchemy/devices/addDevice'
        axios
            .post(dest, this.selected_device)
            .then(rx => {
                // OK
                this.clearAddition()
                this.getAvailableDevices()
                this.getDevices()
                this.alteringDevice = false
            })
            .catch(error => {
                this.alteringDevice = false
                this.processErrorMessage(error)
            });

    },
    setAddition(){
        this.mode = 'addition'
        
    },
    setNewDevice(){
        if(this.deviceToAdd == null){
            return
        }
        this.selected_device.os = this.deviceToAdd.os
        if(this.deviceToAdd.os == 'superficial'){
            this.selected_device.exec_targets = false
            this.selected_device.exec_cpu = false
            this.selected_device.exec_memory = false
            this.selected_device.os = 'superficial'
        }
    },
    clearAddition(){
        this.mode = 'default'
        this.devicesMessage = "..."
        this.selected_device = this.cloneObject(this.default_device)
    },
    // Edition
    editDevice(){
        if (!confirm('Set the changes?')){return}
        this.alteringDevice = true
        this.selected_device.exec_ping = true
        const params = {}
        const dest = this.site + '/alchemy/devices/alterDevice'
        axios
            .post(dest, this.selected_device)
            .then(rx => {
                // OK
                this.getDevices()
                this.alteringDevice = false
                this.mode = 'default'
            })
            .catch(error => {
                this.alteringDevice = false
                this.processErrorMessage(error)
            }); 
    },
    setEdition(_dev, _ind){
        this.selected_device = this.cloneObject(_dev)
        this.selected_device.number = _ind + 1
        this.devicesMessage = "Edition mode."
        if(this.selected_device.os == 'superficial'){
            this.selected_device.exec_targets = false
            this.selected_device.exec_cpu = false
            this.selected_device.exec_memory = false
        }
        this.mode = 'edition'
    },
    clearEdition(){
        this.mode = 'default'
        this.devicesMessage = "..."
        this.selected_device = this.cloneObject(this.default_device)
    },
    // Delete
    deleteDevice(_dev, _ind){
        if (!confirm(`Delete device "${_dev.name}" ?`)){return}
        this.devicesMessage = "Deleting device, please wait..."
        this.deletingDevice = true
        const params = {uid: _dev.uid, name: _dev.name}
        const dest = this.site + '/alchemy/devices/deleteDevice'
        axios
            .post(dest, {params})
            .then(rx => {
                // OK
                var idx = this.devices.indexOf(_dev)
                this.devices.splice(idx, 1)
                this.devicesMessage = rx.data.message
                this.deletingDevice = false
                this.getAvailableDevices()
            })
            .catch(error => {
                this.deletingDevice = false
                this.processErrorMessage(error)
            });
    },
    // Filtering
    setSearchType(search_type){
      this.searchType = search_type
    },

    // CLOUD DEVICES
    setCloudDevices(){
        this.cloud_devices = this.all_cloud_devices[this.cloud_dtype]
    },
    getAvailableCloudDevices(){
        this.cloud_device_to_handle = null
        this.getting_acloud_devices = true
        this.available_cloud_devices = []
        const params = {}
        const dest = this.site + '/alchemy/devices/getAvailableCloudDevices'
        axios
            .get(dest, {params})
            .then(rx => {
                // OK
                this.available_cloud_devices = rx.data.data.devices
                //this.available_cloud_devices = this.available_cloud_devices.filter( cd => cd.os == 'meraki' );
                this.getting_acloud_devices = false
            })
            .catch(error => {
                this.getting_acloud_devices = false
                this.processErrorMessage(error)
        });
    },
    getCloudDevices(){
        this.getting_cloud_devices = true
        //this.devices = []
        const params = {filter: 'all'}
        const dest = this.site + '/alchemy/devices/getCloudDevices'
        axios
            .get(dest, {params})
            .then(rx => {
                // OK
                this.all_cloud_devices = rx.data.data.devices
                this.cloud_devices = this.all_cloud_devices[this.cloud_dtype]
                this.getting_cloud_devices = false
            })
            .catch(error => {
                this.getting_cloud_devices = false
                this.processErrorMessage(error)
        });
    },
    // Addition
    addCloudDevice(){
        this.altering_cloud_device = true
        this.cloud_device_to_handle.limits = this.limits[this.cloud_device_to_handle.role]
        this.cloud_device_to_handle.rawos = this.cloud_device_to_handle.os
        this.cloud_device_to_handle.os = this.oss[this.cloud_device_to_handle.os]
        const dest = this.site + '/alchemy/devices/addCloudDevice'
        axios
            .post(dest, this.cloud_device_to_handle)
            .then(rx => {
                // OK
                this.clearCloudAddition()
                this.getAvailableCloudDevices()
                this.getCloudDevices()
                this.altering_cloud_device = false
            })
            .catch(error => {
                this.altering_cloud_device = false
                this.processErrorMessage(error)
            });
    },
    setCloudAddition(){
        this.mode = 'addition'
    },
    clearCloudAddition(){
        this.mode = 'default'
        this.cloud_device_to_handle = null
        this.clearLimits()
    },
    setNewCloudDevice(){
        if(this.cloud_device_to_handle == null){
            return
        }
    },
    // Edition
    editCloudDevice(){
        if (!confirm('Save the changes?')){return}
        this.altering_cloud_device = true
        const params = {}
        const dest = this.site + '/alchemy/devices/alterCloudDevice'
        axios
            .post(dest, this.cloud_device_to_handle)
            .then(rx => {
                // OK
                this.getCloudDevices()
                this.mode = 'default'
                this.altering_cloud_device = false
            })
            .catch(error => {
                this.altering_cloud_device = false
                this.processErrorMessage(error)
            }); 
    },
    setCloudEdition(_dev){
        this.cloud_device_to_handle = this.cloneObject(_dev)
        this.limits[this.cloud_dtype] = this.cloud_device_to_handle.limits
        this.mode = 'edition'
    },
    clearCloudEdition(){
        this.mode = 'default'
        this.cloud_device_to_handle = null
        this.clearLimits()
    },
    clearLimits(){
        for (const [key, value] of Object.entries(this.limits)) {
            this.resetObject(this.limits[key], 0)
        }
    },
    // Delete
    deleteCloudDevice(_dev, _ind){
        if (!confirm(`Delete device "${_dev.name}" ?`)){return}
        this.deleting_cloud_device = true
        const dest = this.site + '/alchemy/devices/deleteCloudDevice'
        axios
            .post(dest, {uid: _dev.uid, name: _dev.name, role: _dev.role})
            .then(rx => {
                // OK
                var idx = this.cloud_devices.indexOf(_dev)
                this.cloud_devices.splice(idx, 1)
                this.deleting_cloud_device = false
            })
            .catch(error => {
                this.deleting_cloud_device = false
                this.processErrorMessage(error)
            });
    },
    toggleCloudDeviceField(_dev, _ind, _field){
        if (!confirm(`Change device monitoring permission?`)){return}
        this.alteringDevice = true
        this.devicesMessage = "Modifying status of device, please wait..."
        //const params = { uid: _dev.uid, status: !Boolean(_dev[_field]), field: _field, role: _dev.role }
        const dest = this.site + '/alchemy/devices/toggleCloudDeviceField'
        axios
            .post(dest, {uid: _dev.uid, status: !(_dev[_field]), field: _field, role: _dev.role})
            .then(rx => {
                // OK
                //this.getCloudDevices()
                this.cloud_devices[_dev.oridx][_field] = !_dev[_field]
                this.alteringDevice = false
                this.devicesMessage = "..."
            })
            .catch(error => {
                this.processErrorMessage(error)
                this.alteringDevice = false
            });
    },
    // Filtering
    setCloudSearchType(search_type){
        this.search_cloud_type = search_type
    },

    // MISC
    processErrorMessage(error, mode="alert"){
        var err_message = null
        try {
            err_message = error.response.data.data.errorMessage
        } 
        catch (nerror) {
            try { 
                err_message = error.response.data.errorMessage
            } 
            catch (error) { 
                console.log(error) 
            }
        }
        if (mode == "alert"){ alert(err_message)  }
        else if (mode == "console"){ console.log(err_message)  }
        return err_message
    },
    printObject(_object){
        console.log(JSON.stringify(_object, null, "   "))
    },
    capitalize(_string){
        if (_string == null){return ""}
        const lower = String(_string).toLowerCase()
        return String(_string).charAt(0).toUpperCase() + lower.slice(1)
    },
    cloneObject(_object){
      return JSON.parse(JSON.stringify(_object))
    },
    resetObject(ob, val){
      Object.keys(ob).forEach(k => ob[k] = val);
    },
    getImage(base){
        var imgbase = String(base).toLowerCase()
        return this.bases[imgbase]
    },
    getCookie(name){
      const cookies = document.cookie.split(';');
      for (let cookie of cookies) {
            cookie = cookie.trim();
            if (cookie.startsWith(name + '=')) {
              return cookie.substring(name.length + 1);
            }
      }
      return null;
    }
  },
  created: function(){
    //this.appclient = localStorage.getItem('vrfaware_client')
    //this.appServiceUrl = this.appServiceUrl.replace('_CLIENT_NAME_', this.appclient)
    this.stage = process.env.NODE_ENV
    if (this.stage == 'development'){
      this.site = process.env.VUE_APP_SERVICE_URL
    }
    else{
      this.site = `${window.location.protocol}//${window.location.host}/kraken`
    }
    // Setting
    axios.defaults.headers.common['X-CSRFToken'] = this.getCookie('csrf_prt')
    this.clearLimits()
    this.getDevices()
    this.getAvailableDevices()
    this.getCloudDevices()
    this.getAvailableCloudDevices()
  },
  computed: {
    filteredDevices(){
        if (this.searchWord == ''){
            return this.devices
        }
        this.searchWord = this.searchWord.toLowerCase()
        return this.devices.filter( device => String(device[this.searchType]).toLowerCase().includes( this.searchWord ) );
    },
    filteredCloudDevices(){
        if (this.search_cloud_word == ''){
            return this.cloud_devices
        }
        this.search_cloud_word = this.search_cloud_word.toLowerCase()
        return this.cloud_devices.filter( cloud_device => String(cloud_device[this.search_cloud_type]).toLowerCase().includes( this.search_cloud_word ) );
    }
  }
}
</script>

<style scoped>


  .btn-alchemy{
    background-color: rgb(115, 70, 205);
    color: White;
    transition-duration: 0.6s;
  }
  .btn-alchemy:hover{
    background-color: rgb(0, 0, 26);
    color: rgb(115, 70, 205);
  }

  .btn-alchemy-dark{
    background-color: rgb(0,0,26);
    color: White;
    transition-duration: 0.6s;
  }
  .btn-alchemy-dark:hover{
    background-color: rgb(115, 70, 205);
  }

  .btn-alchemy-success{
    background-color: rgb(115, 70, 205);
    color: White;
  }
  .btn-alchemy-danger{
    background-color: rgb(161, 91, 0);
    color: White;
  }
  .btn-alchemy-warning{
    background-color: rgb(187, 255, 0);
    color: rgb(0, 0, 0);
  }
  .btn-alchemy-off{
    background-color: rgb(0, 3, 25);
    color: rgb(161, 91, 0);
  }

  .bg-alchemy{
    background-color: rgb(0, 0, 26);
    color: White
  }
  .bg-alchemy-success{
    background-color: rgb(115, 70, 205);
    color: White;
  }
  .bg-alchemy-danger{
    background-color: rgb(161, 91, 0);
    color: White;
  }
  .bg-alchemy-dark{
    background-color: rgb(0,0,26);
    color: White;
  }

  .border-top-alchemy{
    border-top: solid 1px rgb(115, 70, 205);
  }
  .border-bottom-alchemy{
    border-bottom: solid 1px rgb(115, 70, 205);
  }

  .text-alchemy{
    color: rgb(115, 70, 205);
  }

  .disabled-div{
    pointer-events: none;
    opacity: 0.5;
  }

  .section-button{
    background-color: Black;
    border: solid 2px Black;
    color: White;
  }
  .section-button:hover{
    color: rgb(72,167,238);
    border-bottom: solid 2px rgb(162, 200, 250);
  }


  /* Table with static header */
    .tableFixHead {
        overflow-y: auto;
      }
    .tableFixHead thead th {
        position: sticky;
        top: 0;
        text-align: center;
        z-index: 1;
    }
    table {
        border-collapse: collapse;
        width: 100%;
    }
    th, td {
        padding: 8px 16px;
    }
    th {
        background: #eee;
    }
</style>
